import { Box, Grid, Paper } from "@mui/material";
import CheckLoading from "../base/CheckLoading";
import { LoadStateInfo } from "../../redux/common";
import PrizaGridBar from "../base/grid/PrizaGridBar";
import { UserInfo } from "../../redux/user/userSlice";
import FragmentEmpty from "../base/FragmentEmpty";
import UserPermissionsCard from "./UserPermissionsCard";
import { PermissionId } from "../../app/permissions";

export interface Buttons {
    label: React.ReactNode;
    click: () => void;
}

export interface UserPermissionsGridProps {
    list: UserInfo[];
    state: LoadStateInfo;
    retry?: () => void;
    toolbar: {
        label: React.ReactNode;
        buttons?: Buttons[];
        position?: "top" | "bottom" | undefined;
    }
    messages: {
        empty: string;
        error: string;
    }
    notStarted?: React.ReactNode;
    targetId: string;
    permissions: PermissionId[];
}

const UserPermissionsGrid = (props: UserPermissionsGridProps) => {
    const { list, state, retry, toolbar, messages, notStarted } = props;

    const internalContent = () => {
        const ret = (!list || list.length == 0)
        ? <FragmentEmpty message={messages.empty} />
        : list.map(function (item, i) {
            return <UserPermissionsCard key={i} targetId={props.targetId} permissions={props.permissions} user={item} />;
        });

        return ret;
    };

    const buildContent = () => {
        return <Grid container sx={{}} justifyContent="center" alignContent="center" textAlign="center">
            {internalContent()}
        </Grid>;
    };

    const elToolbar = <PrizaGridBar toolbar={toolbar} retry={retry} />;
    return <Paper sx={{ minWidth: "300px" }} elevation={3}>
        {toolbar.position != "bottom" ? elToolbar : undefined}
        <Box display={"flex"} width="100%">
            <CheckLoading
                states={[state]}
                error={messages.error}
                content={buildContent}
                notStarted={notStarted}
                retry={retry} />
        </Box>
        {toolbar.position == "bottom" ? elToolbar : undefined}
    </Paper>;
};

export default UserPermissionsGrid;